export const EQ_FREQUENCIES = [
  60, 150, 250, 500, 1000, 2000, 4000, 8000, 12000, 16000,
] as const;

export const EQ_BAND_COUNT = EQ_FREQUENCIES.length;

export const EQ_MIN_DB = -12;
export const EQ_MAX_DB = 12;

export function createDefaultEqValues(): number[] {
  return Array(EQ_BAND_COUNT).fill(0);
}

export function isEqFlat(values: number[]): boolean {
  return values.every((value) => value === 0);
}

export function areEqValuesEqual(a: number[], b: number[]): boolean {
  if (a.length !== b.length) return false;
  return a.every((value, index) => value === b[index]);
}
